import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './routes';
import { sessionStore } from './auth/sessionStore';
import { resumeOnThisDevice } from './auth/authService';
import { registerPwa } from './shell/pwa';
// Inter — self-hosted (public/fonts, OFL); CDN запрещён каноном.
import './styles/fonts.css';
import './tokens/tokens.css';
import './styles/global.css';
import './styles/shell.css';
import './styles/screens.css';
import './styles/cluster-a.css';
import './styles/cluster-b.css';
import './styles/cluster-c.css';
import './styles/cluster-d.css';
import './styles/cluster-e.css';
import './styles/cluster-f.css';
// Run 02: правки контрактов и новые примитивы — последним, чтобы перекрывать кластерные сетки.
import './styles/run02.css';
import './styles/concept.css'; // новый визуал (ПЕРЕДАЧА-В-БОЙ.md, шаг 1): поверх всего
import './styles/today.css'; // шаг 2: экран «Сегодня»
import './styles/orders.css'; // шаг 3: экран «Заказы» и панель «Новый заказ»
import './styles/inquiries.css'; // шаг 4: список «Заявки»
import './styles/inquiry-page.css'; // шаг 4: страница заявки и окно «Позиция»
import './styles/counterparties.css'; // шаг 5: «Контрагенты»
import './styles/messages.css'; // шаг 6: «Сообщения»
import './styles/qc.css'; // шаг 7: «ОТК»
import './styles/select.css'; // 12.10: выпадающие списки в стиле ПО
import './styles/purchases.css'; // 12.10: раздел «Закупки»
import './styles/qc-orders.css'; // 12.10: ОТК по заказам, окно заказа, упаковка по готовности ОТК
import './styles/stock.css'; // шаг 8: «Склад»
import './styles/meetings.css'; // встречи, образцы на складе (03.11.2026)
import './styles/products.css'; // шаг 9: «Изделия»
import './styles/order-card.css'; // шаг 10: «Карточка заказа»
import './styles/materials.css'; // остальные экраны: «Материалы и справочники»
import './styles/new-visual.css'; // остальные экраны: «Финансы», «Аналитика», «Настройки», «Кабинет», «Вход»
import './styles/mobile.css'; // телефон и планшет (решения Ромы 05.10.2026): каркас и размеры — последним, действует только при html[data-vp]
import './styles/m-inquiries.css'; // шаг 2: «Заявки»
import './styles/m-orders.css'; // шаг 3: «Заказы»
import './styles/m-today.css'; // шаг 4: «Сегодня»
import './styles/m-messages.css'; // шаг 5: «Сообщения»
import './styles/m-qc.css'; // шаг 6: «ОТК»
import './styles/m-qc-orders.css'; // 12.10: «ОТК» по заказам на телефоне
import './styles/m-stock.css'; // шаг 7: «Склад»
import './shell/viewport'; // ставит html[data-vp] до первой отрисовки (нужно и экрану входа)

sessionStore.restore();
registerPwa(); // значок на экране телефона и push (шаг 8): «служебный помощник» public/sw.js, только в собранном ПО

/**
 * После выкладки новой сборки у открытой вкладки старые имена файлов экранов:
 * переход на страницу падает с «Failed to fetch dynamically imported module».
 * Один раз перезагружаем страницу — новая сборка подхватится сама (Рома, 07.09).
 */
window.addEventListener('vite:preloadError', (e) => {
  const key = 'wg_reload_after_deploy';
  try {
    if (sessionStorage.getItem(key) === location.href) return; // уже перезагружались — не зацикливаться
    sessionStorage.setItem(key, location.href);
  } catch { /* приватный режим — просто перезагрузим */ }
  e.preventDefault();
  location.reload();
});

const basename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';
const router = createBrowserRouter(routes, { basename });

function mount(): void {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}

/**
 * Если сессии во вкладке нет, но устройство запомнено (0058) — меняем токен
 * устройства на сессию ДО отрисовки. Иначе человек увидел бы экран входа,
 * который через мгновение сам исчезнет.
 *
 * Ждём мы только этот один вызов и только когда есть что менять: на устройстве
 * без памяти приложение стартует как раньше, без задержки.
 */
if (sessionStore.isAuthenticated()) {
  mount();
} else {
  void resumeOnThisDevice().finally(mount);
}
